import createIcon from '@/lib/create-icon'

const CandlesIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
    <path d='M11 3.5C11 3.22386 11.2239 3 11.5 3H13.5C13.7761 3 14 3.22386 14 3.5V12.5C14 12.7761 13.7761 13 13.5 13H11.5C11.2239 13 11 12.7761 11 12.5V3.5Z' />
    <path d='M6 6.5C6 6.22386 6.22386 6 6.5 6H8.5C8.77614 6 9 6.22386 9 6.5V15.5C9 15.7761 8.77614 16 8.5 16H6.5C6.22386 16 6 15.7761 6 15.5V6.5Z' />
    <path d='M7 4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6.5C8 6.77614 7.77614 7 7.5 7C7.22386 7 7 6.77614 7 6.5V4.5Z' />
    <path d='M12 12.5C12 12.2239 12.2239 12 12.5 12C12.7761 12 13 12.2239 13 12.5V14.5C13 14.7761 12.7761 15 12.5 15C12.2239 15 12 14.7761 12 14.5V12.5Z' />
  </svg>,
  'CandlesIcon'
)

export default CandlesIcon
